export default __webpack_public_path__ + "static/media/480_private03-en-web.0abc6ce2.png";